import React from 'react';
import styled, { css } from 'styled-components';

import { trlsKeyStageSubPhase } from '../consts/typesStageSubPhase';
import mediaWidth from '../../../utils/mediaWidth/mediaWidth';
import { Font, FontWeight } from '../../../utils/fonts';
import { OpacityReady } from '../consts/other';
import typograf from '../../../utils/typograf';
import Color from '../../../utils/colors';

import SucIcn from '../assets/suc-black-icn.svg';
import ErrIcn from '../assets/err-white-icn.svg';

import ArrowSucLeft from '../assets/arrow-blue-left.svg';
import ArrowLeft from '../assets/arrow-black-left.svg';
import ArrowSucRight from '../assets/arrow-blue.svg';
import ArrowRight from '../assets/arrow-black.svg';

class SubPhaseStages extends React.PureComponent {
    constructor(props) {
        super(props);
        this.isResize = false;

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
        if (!this.isResize) {
            this.isResize = true;
            setTimeout(() => {
                this.isResize = false;
                this.forceUpdate();
            }, 150);
        }
    }

    render() {
        const {
            items, className, results, refContainer,
            stage, risks, isReady,
            changeStage,
        } = this.props;

        const keysItems = Object.keys(items);

        return (
            <Container className={className} id="container-stages" ref={refContainer}>
                <CardsWrapper index={stage} itemsCount={keysItems.length}>
                    {keysItems.map((key, index) => (
                        <Card
                            index={index}
                            isReady={isReady}
                            key={key.toString()}
                            currentIndex={stage}
                            isActive={stage === index}
                        >
                            <CardTitle>{typograf.execute(trlsKeyStageSubPhase[key])}</CardTitle>
                            <CardDescription>
                                {typeof items[key] !== 'string' ? (
                                    Array.isArray(items[key]) ? items[key].map((item, indexI) => (
                                        <CardItem isSimple key={indexI.toString()}>
                                            {typograf.execute(item)}
                                        </CardItem>
                                    )) : items[key].text.map((item, indexI) => (
                                        <CardItem
                                            noPoints={items[key].noPoints}
                                            isSimple
                                            key={indexI.toString()}
                                        >
                                            {typograf.execute(item)}
                                        </CardItem>
                                    ))
                                ) : typograf.execute(items[key])}
                            </CardDescription>
                        </Card>
                    ))}
                    <SucCard
                        isActive={stage === keysItems.length}
                        currentIndex={stage}
                        index={keysItems.length}
                    >
                        <CardTitle>{typograf.execute('Для перехода к следующе&shy;му нужно:')}</CardTitle>
                        <div>
                            {results.map((result, index) => (
                                <LastCardItem key={index.toString()}>
                                    <img alt="icn" src={SucIcn} />
                                    <div>{typograf.execute(result)}</div>
                                </LastCardItem>
                            ))}
                        </div>
                    </SucCard>
                    <ErrCard
                        isActive={stage === keysItems.length + 1}
                        currentIndex={stage}
                        index={keysItems.length + 1}
                    >
                        <CardTitle>{typograf.execute('риски, если пропустить:')}</CardTitle>
                        <div>
                            {risks.map((risk, index) => (
                                <LastCardItem key={index.toString()}>
                                    <img alt="icn" src={ErrIcn} />
                                    <div>{typograf.execute(risk)}</div>
                                </LastCardItem>
                            ))}
                        </div>
                    </ErrCard>
                </CardsWrapper>
                <ControlRow isReady={isReady}>
                    <Pagination>
                        {(new Array(keysItems.length).fill(undefined)).map((_, index) => (
                            <PaginationItem
                                key={index.toString()}
                                onClick={() => changeStage(index)}
                                isActive={index === stage}
                            />
                        ))}
                    </Pagination>
                    <Pagination>
                        <ControlArrowLeft
                            isActive={stage > 0}
                            onClick={() => (stage > 0
                                ? changeStage(stage - 1)
                                : {})}
                        />
                        <ControlArrowRight
                            isActive={stage < keysItems.length - 1}
                            onClick={() => (stage < keysItems.length - 1
                                ? changeStage(stage + 1)
                                : {})}
                        />
                    </Pagination>
                </ControlRow>
            </Container>
        );
    }
}

const Container = styled.div`
  width: 100%;
  ${mediaWidth.m} {
    position: relative;
    height: 331px;
    padding-top: 321px;
  }
  ${mediaWidth.xl} {
    position: relative;
    height: 371px;
    padding-top: 361px;
  }
`;

const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaWidth.m} {
    flex-direction: row;
    align-items: flex-start;
    position: absolute;
    z-index: 0;
    top: 0;
    left: -${({ index, itemsCount }) => {
        const currentLeft = index * 290;
        const maxLeft = itemsCount * 290 - 117 - (window.innerWidth - 768);
        if (index >= itemsCount - 1) {
            return maxLeft;
        }
        return currentLeft;
    }}px;
    transition: left .7s;
  }

  ${mediaWidth.l} {
    left: -${({ index, itemsCount }) => {
        const currentLeft = index * 307;
        const maxLeft = (itemsCount - 1) * 307 - (window.innerWidth - 1024);
        if (index >= itemsCount - 1) {
            return maxLeft;
        }
        return currentLeft;
    }}px;
  }

  ${mediaWidth.xl} {
    left: -${({ index, itemsCount }) => {
        const currentLeft = index * 328;
        const maxLeft = (itemsCount - 1) * 328 - (window.innerWidth - 1440);
        if (index >= itemsCount - 1) {
            return maxLeft;
        }
        return currentLeft;
    }}px;
  }
`;

export const CardTitle = styled.div`
  ${Font.HEADLINE};
  ${FontWeight.MEDIUM};
  text-transform: uppercase;
  color: ${Color.SECONDARY};
  font-size: 16px;
  line-height: 18px;

  text-align: center;

  ${mediaWidth.m} {
    color: #FFF;
    text-align: left;
    font-size: 22px;
    line-height: 25px;
  }
  ${mediaWidth.xl} {
    font-size: 24px;
    line-height: 27px;
  }
`;

const CardItem = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
  padding-left: 16px;

  color: #000;
  ${({ isSimple }) => (isSimple ? 'color: #FFF;' : '')}
  ${Font.PRIMARY};
  ${FontWeight.REGULAR};
  font-size: 14px;
  line-height: 18px;
  text-align: left;
  &:first-child { margin-top: 16px }

  ${({ noPoints }) => (noPoints ? '' : `
  &::after {
    position: absolute;
    content: '';
    top: 2px;
    left: 0;
    width: 8px;
    height: 8px;
    background-color: #FFF;
    border-radius: 100%;
  }`)}

  ${mediaWidth.m} {
    justify-content: flex-start;
    margin-top: 12px;
    text-align: left;
  }
  ${mediaWidth.xl} {
    font-size: 16px;
    line-height: 24px;
  }
`;

const CardDescription = styled.div`
  margin-top: 16px;
  ${Font.PRIMARY};
  ${FontWeight.REGULAR};

  color: #FFF;
  font-size: 14px;
  line-height: 18px;
  text-align: center;

  white-space: pre-line;

  ${mediaWidth.m} {
    color: #000;
    text-align: left;
  }
  ${mediaWidth.xl} {
    font-size: 16px;
    line-height: 24px;
  }
`;

const Card = styled.div`
  width: 328px;
  padding: 24px;
  border: 1px solid ${Color.SECONDARY};
  ${({ isReady }) => (isReady ? css`opacity: ${OpacityReady};` : '')}
  transition: width .2s, padding .2s;

  ${CardDescription} { display: none; }

  ${({ isActive, index, currentIndex }) => {
        if (isActive) {
            return css`
            border: none;
            background-color: ${Color.SECONDARY};
            ${CardDescription} { display: block; }
            ${CardTitle} { color: #FFF; }
            `;
        }
        const factor = Math.abs(currentIndex - index);
        return css`
          width: ${328 - factor * 24}px;
          padding: ${24 - factor * 2}px;
          ${CardTitle} { font-size: ${16 - factor * 1.3}px }
        `;
    }}

  ${mediaWidth.m} {
    width: 266px;
    height: 288px;

    background-color: #65A0F8;
    border: 0;
    padding: 24px;
    ${CardDescription} { display: block; }
    ${CardTitle} { font-size: 22px }

    &:not(:last-child) {
      margin-right: 24px;
    }

    &:nth-child(even) {
      background-color: #0032A0;
      ${CardDescription} {
        color: #FFF;
      }
      ${CardItem} {
        color: #FFF;
      }
    }
  }

  ${mediaWidth.l} {
    width: 283px;
  }

  ${mediaWidth.xl} {
    width: 296px;
    height: 328px;
    padding: 32px 24px 24px;

    &:not(:last-child) {
      margin-right: 32px;
    }
  }
`;

export const LastCardItem = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;

  color: #000;
  ${Font.PRIMARY};
  ${FontWeight.REGULAR};
  font-size: 14px;
  line-height: 18px;
  text-align: left;

  img { margin-right: 8px; align-self: flex-start; margin-top: -3px; }
  &:first-child { margin-top: 16px }

  ${mediaWidth.m} {
    justify-content: flex-start;
    margin-top: 12px;
    text-align: left;
  }
  ${mediaWidth.xl} {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const SucCard = styled(Card)`
  ${LastCardItem} { display: none }
  ${({ isActive }) => (isActive ? css`
    border: none;
    background-color: #24D882 !important;
    ${LastCardItem} { display: flex; }
    ${CardTitle} { color: #FFF !important; }
  ` : '')}
  ${mediaWidth.m} {
    background-color: #24D882 !important;
    ${LastCardItem} { display: flex; }
  }
`;

export const ErrCard = styled(Card)`
  ${LastCardItem} { display: none }
  ${({ isActive }) => (isActive ? css`
    border: none;
    background-color: #FF5A55 !important;
    ${LastCardItem} { display: flex; color: #FFF !important; }
    ${CardTitle} { color: #FFF !important; }
  ` : '')}
  ${mediaWidth.m} {
    background-color: #FF5A55 !important;
    ${LastCardItem} { display: flex; color: #FFF; }
  }
`;

const ControlRow = styled.div`
  height: 10px;

  display: none;
  justify-content: space-between;
  align-items: center;
  ${({ isReady }) => (isReady ? css`opacity: ${OpacityReady};` : '')}
  ${mediaWidth.m} {
    display: flex;
  }
`;

const Pagination = styled.div`
  display: flex;
`;

const ControlArrow = styled.div`
  width: 54px;
  height: 10px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  cursor: pointer;
`;

const ControlArrowLeft = styled(ControlArrow)`
  margin-right: 16px;
  background-image: url("${({ isActive }) => (isActive ? ArrowSucLeft : ArrowLeft)}");
`;

const ControlArrowRight = styled(ControlArrow)`
  background-image: url("${({ isActive }) => (isActive ? ArrowSucRight : ArrowRight)}");
`;

const PaginationItem = styled.div`
  position: relative;
  width: 37px;
  height: 2px;

  background-color: ${({ isActive }) => (isActive ? '#0032A0' : 'rgba(0, 0, 0, 0.32)')};
  cursor: pointer;

  &:not(:last-child) {
    margin-right: 8px;
  }

  &::after {
    position: absolute;
    content: '';
    top: -14px;
    left: 0;
    width: 100%;
    height: 30px;
    cursor: pointer;
  }

  ${mediaWidth.l} {
    width: 56px;
  }
`;

export default SubPhaseStages;
